import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["bodyField", "results"]

  initialize() {
    this.debounceTimer = null
  }

  search() {
    clearTimeout(this.debounceTimer)
    const query = this.bodyFieldTarget.value.trim()

    if (query.length < 3) {
      this.resultsTarget.innerHTML = ""
      return
    }

    this.debounceTimer = setTimeout(() => {
      this.fetchResults(query)
    }, 300)
  }

  fetchResults(query) {
    const url = `/planning/comment_library_items/search?q=${encodeURIComponent(query)}`

    fetch(url, {
      headers: {
        "Accept": "text/html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then(response => response.text())
      .then(html => {
        this.resultsTarget.innerHTML = html
      })
  }

  selectItem(event) {
    const body = event.currentTarget.dataset.body
    this.bodyFieldTarget.value = body
    this.resultsTarget.innerHTML = ""
  }
}
